import produce from 'immer';
import { handleActions } from 'redux-actions';

import actions from './actions';
import { updateStoreWithPath } from '../../../../lib/common';
import { ACCOUNT_USER_LIST_FILTER_OPTION_MODEL, ACCOUNT_USER_LIST_SORT_OPTION_MODEL } from './models';
import { LIST_PAGINATION_MODEL, LIST_SUMMARY_MODEL } from '../../app/models';

/**
 *  INITIAL STATE
 */
const initialState = {
  /**
   * 유저 리스트
   */
  accountUserList: {
    /**
     * 리스트
     */
    list: [],
    /**
     *  검색 옵션
     */
    filterOption: ACCOUNT_USER_LIST_FILTER_OPTION_MODEL,
    /**
     *  정렬 옵션 리스트
     */
    sortOption: ACCOUNT_USER_LIST_SORT_OPTION_MODEL,
    /**
     *  리스트 pagination
     */
    pagination: LIST_PAGINATION_MODEL,
    /**
     *  집계 데이터
     */
    summary: LIST_SUMMARY_MODEL,
  },

  /**
   * 유저 랭킹 리스트
   */
  accountUserRankList: {
    /**
     * 리스트
     */
    list: [],
    /**
     *  검색 옵션
     */
    filterOption: ACCOUNT_USER_LIST_FILTER_OPTION_MODEL,
    /**
     *  정렬 옵션 리스트
     */
    sortOption: ACCOUNT_USER_LIST_SORT_OPTION_MODEL,
    /**
     *  리스트 pagination
     */
    pagination: LIST_PAGINATION_MODEL,
    /**
     *  집계 데이터
     */
    summary: LIST_SUMMARY_MODEL,
  },

  /**
   *  유저 태그 타임라인 리스트 모달
   */
  accountUserTagLogModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  좋아요한 상품 타임라인 리스트 모달
   */
  accountUserLikeProductLogModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  좋아요한 브랜드 타임라인 리스트 모달
   */
  accountUserLikeBrandLogModal: {
    isOpen: false,
    data: {},
  },
};

/**
 *  REDUCER
 */
export default handleActions(
  {
    /**
     *  [유저] 유저 데이터 변경하기
     */
    [actions.SET_DATA]: (state, action) => {
      return produce(state, (draft) => {
        updateStoreWithPath(
          action.payload.path,
          { ...draft.accountUserDetail.userInfoTab.userPersonalInfo, ...action.payload.value },
          draft,
        );
      });
    },

    /**
     *  [유저] 유저 리스트 요청하기
     */
    [actions.GET_USER_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  유저 리스트
         */
        draft.accountUserList = action.payload.accountUserList;
      });
    },

    /**
     *  [유저] 유저 랭킹 요청하기
     */
    [actions.GET_USER_RANK_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  유저 리스트
         */
        draft.accountUserRankList = action.payload.accountUserRankList;
      });
    },

    /**
     * [포인트 발급 모달] 포인트 발급 하고 유저 상세 포인트 내역 업데이트
     */
    [actions.GENERATE_POINT_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  유저 상세 > 유저 정보 > 포인트 내역 업데이트
         */
        draft.accountUserDetail.pointInfoTab.pointHistoryList.list.unshift(action.payload.pointLog);
        /**
         *  유저 상세 > 유저 정보 > 포인트 내역 > 포인트 내역 총 갯수 업데이트
         */
        draft.accountUserDetail.pointInfoTab.pointHistoryList.summary.totalCnt += 1;
        /**
         *  유저 상세 > 유저 정보 > 포인트 내역 > 포인트 업데이트
         */
        draft.accountUserDetail.userInfoTab.userPersonalInfo.pointAmount = action.payload.pointInfo.credit;
        /**
         *  유저 상세 > 유저 정보 > 포인트 내역 > 사용된 포인트 업데이트
         */
        draft.accountUserDetail.userInfoTab.userPersonalInfo.usedPointAmount = action.payload.pointInfo.usedCredit;
      });
    },

    /**
     *  모달 토글
     */
    [actions.TOGGLE_MODAL]: (state, action) => {
      return produce(state, (draft) => {
        action.payload.data && updateStoreWithPath([action.payload.name, 'data'], action.payload.data, draft);
        updateStoreWithPath([action.payload.name, 'isOpen'], action.payload.value, draft);
      });
    },
  },
  initialState,
);
